// extracted by mini-css-extract-plugin
export default {"JobworkPage":"JobworkPage_JobworkPage__lKfVP"};